import * as React from 'react'
import { useRouteError } from 'react-router-dom'
import config from '../config'
import { DefaultError, reportErrorToSentry } from '../components/AppError'

/** Root data-router error UI; mirrors {@link AppError} for render errors under `RouterProvider`. */
export function RouteErrorFallback() {
  const error = useRouteError()

  React.useEffect(() => {
    if (config.DEV) {
      // eslint-disable-next-line no-console
      console.error('Route error:', error)
    }
    reportErrorToSentry(error)
  }, [error])

  return <DefaultError />
}
